<template>
  <div id="refactor-about">
    <header-menu></header-menu>
    <div class="header-ab-banner"
         :style="{ backgroundImage: `url(${about.bannData.coverImage || 'https://cdn.huimiaokeji.com/bj_gy2x.png'})` }">
      <div class="banner-ab-content">
        <h1 class="banner-ab-title">{{ about.bannData.title || '关于我们' }}</h1>
        <p class="banner-ab-description">{{ about.bannData.summary || '灰鲸网络，一家致力于为开发者提供一站式的流量变现服务的公司' }}</p>
      </div>
    </div>
    <!-- 公司模块 -->
    <div class="company-module">
      <div class="company-content">
        <h2 class="company-title">{{ about.compData.type || '灰鲸网络科技有限公司' }}</h2>
        <p class="company-summary">{{ about.compData.title || '专注于为企业提供优质的网络技术解决方案' }}</p>
        <div class="company-details">
          <div class="company-image">
            <img :src="about.compData.coverImage || 'https://cdn.huimiaokeji.com/bj_kh@2x.png'" alt="公司图片"/>
          </div>
          <div class="company-description-wrapper">
            <div class="company-description">
              <div v-html="currentText"></div>
            </div>
            <!-- 轮播切换按钮 -->
            <div class="carousel-buttons" v-if="textPages.length > 1">
              <button v-for="(page, index) in textPages" :key="index"
                      :class="{ active: currentPage === index }"
                      @click="switchPage(index)"></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 企业文化 -->
    <div class="culture-module">
      <div class="culture-content">
        <h2 class="culture-title">{{ about.cultData[0].type || '企业文化' }}</h2>
        <p class="culture-summary">{{
            about.cultData[0].title || '我们坚持创新、协作、诚信的核心价值观，为客户创造价值'
          }}</p>
        <div class="culture-details">
          <!-- 左侧区域 -->
          <div class="culture-left" v-for="(item, index) in about.cultData" :key="index">
            <img :src="item.coverImage" alt="企业文化图片" class="culture-image"/>
            <div class="culture-overlay">
              <h3 class="culture-desc-title">{{ item.createBy || '企业文化' }}</h3>
              <p class="culture-description">
                {{
                  item.remark || '灰鲸网络秉承着创新、协作、诚信的企业文化，不断追求卓越，为客户提供最优质的服务和解决方案。我们相信团队的力量，注重每一位员工的成长和发展。'
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司环境 -->
    <div class="environment-module">
      <div class="environment-content">
        <h2 class="environment-title">{{ about.envrData[0].type || '公司环境' }}</h2>
        <p class="environment-summary">{{ about.envrData[0].title || '舒适的办公环境，激发无限创造力' }}</p>
        <div class="environment-images">
          <div class="image-container">
            <img :src="imageLeft.src" alt="左侧图片" class="left-image" @click="switchImage(imageLeft.index)"/>
          </div>
          <div class="image-container center">
            <img :src="imageCenter.src" alt="中间图片" class="center-image"/>
          </div>
          <div class="image-container">
            <img :src="imageRight.src" alt="右侧图片" class="right-image"
                 @click="switchImage(imageRight.index)"/>
          </div>
        </div>
      </div>
    </div>

    <footer-menu
        title="接入灰鲸广告联盟，开启APP广告变现之旅!"
        buttonText="立即接入"
        buttonLink="https://admin.huimiaokeji.com"
    ></footer-menu>
    <floating-modal ref="floatingModal"></floating-modal>
  </div>
</template>

<script>
import {getAboutInfo} from '../../api/index.js';
import FooterMenu from '../../components/footer-menu.vue';
import HeaderMenu from "../../components/header-menu.vue";
import FloatingModal from "~/components/floating-modal.vue";

export default {
  name: 'About',
  components: {
    FloatingModal,
    HeaderMenu,
    FooterMenu
  },
  data() {
    return {
      about: {
        bannData: {
          title: '关于我们',
          summary: '灰鲸网络，一家致力于为开发者提供一站式的流量变现服务的公司',
        },
        compData: {},
        cultData: [],
        envrData: [],
      },
      textPages: [], // 存储分割后的文本页
      currentPage: 0, // 当前页码
      linesPerPage: 10, // 每页展示行数
      // 图片轮询相关数据
      images: [
        {id: 1, src: 'https://cdn.huimiaokeji.com/hjweb/env_1.jpg'},
        {id: 2, src: 'https://cdn.huimiaokeji.com/hjweb/env_2.jpg'},
        {id: 3, src: 'https://cdn.huimiaokeji.com/hjweb/env_3.jpg'}
      ],
      imageLeft: {id: 3, src: 'https://cdn.huimiaokeji.com/hjweb/env_3.jpg'},
      imageCenter: {id: 1, src: 'https://cdn.huimiaokeji.com/hjweb/env_1.jpg'},
      imageRight: {id: 2, src: 'https://cdn.huimiaokeji.com/hjweb/env_2.jpg'}
    }
  },
  computed: {
    currentText() {
      return this.textPages[this.currentPage] || '';
    }
  },
  created() {
    document.title = '灰鲸网络-关于我们';
    this.queryAboutInfo();
  },
  methods: {
    async queryAboutInfo() {
      let res = await getAboutInfo();
      if (res.code == 200) {
        this.about = res.data
        this.splitTextIntoPages();
        // 如果有环境数据，使用环境数据的图片
        if (this.about.envrData && this.about.envrData.length > 0) {
          this.images = this.about.envrData.filter(item => item.coverImage).map((item, index) => ({
            index,
            id: item.id || Date.now() + Math.random(),
            src: item.coverImage
          }));
          if (this.images.length > 0) {
            // 初始化图片位置
            this.imageLeft = this.images[0];
            this.imageCenter = this.images[1];
            this.imageRight = this.images[2];
          }
        }
      }
    },
    // 将文本分割成多页，每页展示指定行数
    splitTextIntoPages() {
      const description = this.about.compData.summary || '我们以先进的技术，构建了全行业领先的全栈式程序化流量变现平台，凭借创新的智能化广告生态系统，可实现流量变现全过程透明化，有效保证媒体利益的最大化。 作为一家总部位于互联网之都 · 杭州的互联网公司，灰鲸网络拥有一支充满激情和创造力的团队。我们相信，只有不断创新和进步，才能在竞争激烈的互联网市场中立于不败之地。灰鲸网络凭借着灵敏的嗅觉，不断关注行业动向，勇于探索新领域、新技术、新模式，始终为客户提供最优质的服务和全方位的解决方案。';
      // 按句号分割句子，便于后续组合
      const sentences = description.split('。').filter(s => s.trim());
      const pages = [];
      let currentPage = '';
      let currentLineCount = 0;

      sentences.forEach((sentence, index) => {
        // 添加句号回到句子末尾
        const fullSentence = sentence + '。';

        // 计算当前句子大概占用的行数（假设每行约36个字符）
        const sentenceLines = Math.ceil(fullSentence.length / 56);

        // 如果添加当前句子会超过每页行数限制，则创建新页
        if (currentLineCount + sentenceLines > this.linesPerPage) {
          if (currentPage) {
            pages.push(currentPage);
          }
          currentPage = fullSentence;
          currentLineCount = sentenceLines;
        } else {
          currentPage += fullSentence;
          currentLineCount += sentenceLines;
        }

        // 处理最后一个句子
        if (index === sentences.length - 1 && currentPage) {
          pages.push(currentPage);
        }
      });

      this.textPages = pages;
      this.currentPage = 0;
    },

    // 切换页面
    switchPage(pageIndex) {
      this.currentPage = pageIndex;
    },

    // 切换图片位置，实现轮询效果
    switchImage(index) {
      const imagesLength = this.images.length;
      const validIndex = Math.max(0, Math.min(index, imagesLength - 1));
      // 计算上一个索引（循环）
      let prevIndex = (validIndex - 1 + imagesLength) % imagesLength;
      // 计算下一个索引（循环）
      let nextIndex = (validIndex + 1) % imagesLength;

      if (index == 0) {
        prevIndex = imagesLength - 1;
      }
      if (index == imagesLength - 1) {
        nextIndex = 0;
      }
      this.imageCenter = this.images[validIndex];
      this.imageRight = this.images[nextIndex];
      this.imageLeft = this.images[prevIndex];
    }
  }
}
</script>

<style lang="less">
#refactor-about {
  background-color: #F3F7FF;

  .header-ab-banner {
    margin-top: 80px;
    height: 240px;
    //background: url(https://cdn.huimiaokeji.com/bj_gy2x.png) no-repeat;
    background-size: 100% 240px;
    width: 100%;
    display: flex;
    //align-items: center;
    //justify-content: center;
  }

  .banner-ab-content {
    width: 820px;
    //text-align: center;
    margin-left: 120px;
  }

  .banner-ab-title {
    font-size: 34px;
    margin-top: 70px;
    color: #0B00B5;
    margin-bottom: 16px;
    font-weight: bold;
    //text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .banner-ab-description {
    font-size: 18px;
    font-weight: 400;
    color: #051940;
    margin-bottom: 40px;
    //text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
  /* 公司模块样式 */

  .company-module {
    padding: 100px 0; /* 上下间距100px */
    background-color: #fff;
  }

  .company-content {
    max-width: calc(100% - 240px); /* 左右间距120px */
    margin: 0 auto;
  }

  .company-title {
    font-size: 28px;
    color: #0B00B5;
    text-align: center;
    margin-bottom: 16px;
    line-height: 1.4;
  }

  .company-summary {
    font-size: 18px;
    color: #8F9699;
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.4;
  }

  .company-details {
    display: flex;
    align-items: flex-start;
    margin: 0 70px 0 40px;
    gap: 40px; /* 图片和描述间隔40px */
  }

  .company-image {
    width: 470px;
    height: 264px;
    overflow: hidden;
    border-radius: 8px;
  }

  .company-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .company-description-wrapper {
    flex: 1;
    /* 移除overflow-x: auto;，取消滚动条 */
    /* 移除max-height: 264px;，允许内容自然高度 */
  }

  .company-description {
    font-size: 15px;
    color: #5D5454;
    line-height: 1.8;
    white-space: normal;
    padding-bottom: 10px;
  }

  /* 轮播切换按钮样式 */

  .carousel-buttons {
    display: flex;
    //justify-content: center;
    gap: 10px;
    position: relative;
    bottom: auto;
    left: auto;
    right: auto;
    margin-top: 20px;
  }

  .carousel-buttons button {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #0B00B5;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .carousel-buttons button.active {
    width: 60px;
    height: 12px;
    border-radius: 6px;
    border: 1px solid #0B00B5;
    background-color: #fff;
    transform: none;
  }

  .carousel-buttons button:hover {
    background-color: #eee;
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .company-content {
      max-width: calc(100% - 80px); /* 小屏幕减小左右间距 */
    }

    .company-image {
      width: 400px;
      height: 225px;
    }
  }

  @media (max-width: 768px) {
    .company-details {
      flex-direction: column;
      gap: 20px;
    }

    .company-image {
      width: 100%;
      height: auto;
    }

    .company-description {
      white-space: normal; /* 小屏幕下文本自动换行 */
    }
  }

  /* 企业文化模块样式 */

  .culture-module {
    padding: 100px 0; /* 上下间距100px */
    background-color: #F3F7FF;
  }

  .culture-content {
    max-width: calc(100% - 240px); /* 左右间距120px */
    margin: 0 auto;
  }

  .culture-title {
    font-size: 28px;
    color: #0B00B5;
    text-align: center;
    margin-bottom: 16px;
    line-height: 1.4;
    white-space: normal; /* 标题换行展示 */
  }

  .culture-summary {
    font-size: 18px;
    color: #8F9699;
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.4;
    white-space: normal; /* 概述换行展示 */
  }

  .culture-details {
    display: flex;
    gap: 40px; /* 中间间距40px */
    justify-content: center;
  }

  .culture-left {
    width: 580px;
    height: 462px;
    background: #DDE5F4;
    padding: 20px;
    position: relative;
    box-sizing: border-box;
  }

  .culture-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .culture-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.85);
    padding: 20px 40px 40px 40px;
    box-sizing: border-box;
  }

  .culture-desc-title {
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
  }

  .culture-description {
    color: #5D5454;
    font-size: 14px;
    line-height: 1.6;
  }

  /* 公司环境模块样式 */

  .environment-module {
    padding: 100px 0; /* 上下间距100px */
    background-color: #fff;
  }

  .environment-content {
    max-width: calc(100% - 240px); /* 左右间距120px */
    margin: 0 auto;
  }

  .environment-title {
    font-size: 28px;
    color: #0B00B5;
    text-align: center;
    margin-bottom: 16px;
    line-height: 1.4;
    white-space: normal; /* 标题换行展示 */
  }

  .environment-summary {
    font-size: 18px;
    color: #8F9699;
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.4;
    white-space: normal; /* 概述换行展示 */
  }

  .environment-images {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px; /* 图片左右间距40px */
  }

  .images-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap; // 允许图片换行
    gap: 20px; // 图片之间的间距
  }

  .left-image,
  .right-image {
    width: 400px;
    height: 241px;
    object-fit: cover;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .left-image:hover,
  .right-image:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .center-image {
    width: 800px;
    height: 482px;
    object-fit: cover;
  }

  /* 响应式设计 */
  @media (max-width: 1600px) {
    .environment-content {
      max-width: calc(100% - 80px); /* 小屏幕减小左右间距 */
    }

    .left-image,
    .right-image {
      width: 800px;
      height: 482px;
    }
  }

  @media (max-width: 1200px) {
    .environment-images {
      flex-direction: column;
      gap: 20px;
    }

    .left-image,
    .right-image,
    .center-image {
      width: 100%;
      height: auto;
      max-width: 800px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/refactor/About.vue